export const TIME_GRADIENTS = {
    dawn: {
        colors: ['#e6d5e8', '#FFFFFF', '#FFFFFF'],
        start: 5,  // 5 AM
        end: 8     // 8 AM
    },
    morning: {
        colors: ['#b68fb5', '#FFFFFF', '#FFFFFF'],
        start: 8,  // 8 AM
        end: 11    // 11 AM
    },
    noon: {
        colors: ['#54d4f8', '#FFFFFF', '#FFFFFF'],
        start: 11, // 11 AM
        end: 14    // 2 PM
    },
    afternoon: {
        colors: ['#24a8f0', '#FFFFFF', '#FFFFFF'],
        start: 14, // 2 PM
        end: 17    // 5 PM
    },
    evening: {
        colors: ['#147cc8', '#FFFFFF', '#FFFFFF'],
        start: 17, // 5 PM
        end: 20    // 8 PM
    },
    night: {
        colors: ['#122878', '#FFFFFF', '#FFFFFF'],
        start: 20, // 8 PM
        end: 23    // 11 PM
    },
    midnight: {
        colors: ['#221550', '#FFFFFF', '#FFFFFF'],
        start: 23, // 11 PM
        end: 5     // 5 AM
    }
}; 